module.exports = __webpack_public_path__ + "8414c362eaaff96df2d9b1971b134cb1.ico";